<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Configuración general</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<table v-if="data" class="table table-hover table-striped table-condensed">
								<tbody>
									<tr :id="'setting-' + data.id +'-display_profit'">
										<td>Mostrar margen de beneficio</td>
										<td>
											<div class="pull-right">
												<input @change="update('display_profit', {display_profit:data.display_profit})" type="checkbox" v-model="data.display_profit" class="js-switch pull-right" data-size="small">
											</div>
										</td>
									</tr>
									<tr :id="'setting-' + data.id +'-auto_generate_orders'">
										<td>Generar pedidos automáticamente</td>
										<td>
											<div class="pull-right">
												<input @change="update('auto_generate_orders', {auto_generate_orders:data.auto_generate_orders})" type="checkbox" v-model="data.auto_generate_orders" class="js-switch pull-right" data-size="small">
											</div>
										</td>
									</tr>
									<tr :id="'setting-' + data.id +'-tax_id'">
										<td>Impuesto por defecto</td>
										<td>
											<template v-if="taxes">
												<template v-if="taxes.length">
													<div class="pull-right">
														<select @change="update('tax_id', {tax_id:data.tax_id})" class="form-control" v-model="data.tax_id">
															<option v-for="tax in taxes" :value="tax.id">{{ tax.name }}</option>
														</select>
													</div>
												</template>
											</template>
										</td>
									</tr>
									<tr :id="'setting-' + data.id +'-payment_method_id'">
										<td>Método de pago</td>
										<td>
											<template v-if="payment_methods">
												<template v-if="payment_methods.length">
													<div class="pull-right">
														<select @change="update('payment_method_id', {payment_method_id:data.payment_method_id})" class="form-control" v-model="data.payment_method_id">
															<option v-for="payment_method in payment_methods" :value="payment_method.id">{{ payment_method.name }}</option>
														</select>
													</div>
												</template>
											</template>
										</td>
									</tr>
									<tr :id="'setting-' + data.id +'-use_delivery_note'">
										<td>Habilitar Albarán</td>
										<td>
											<div class="pull-right">
												<input @change="update('use_delivery_note', {use_delivery_note:data.use_delivery_note})" type="checkbox" v-model="data.use_delivery_note" class="js-switch pull-right" data-size="small">
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-general'
				},

				loading: false,

				data: null,
				taxes: null,
				payment_methods: null,
			}
		},
		methods: {
			open() {
				this.clearData()
				this.getData()
				this.getTaxes()
				this.getPaymentMethods()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.getData()
			},
			clearData() {
				this.data = null
			},
			getTaxes() {
				this.$http.get('admin/management/taxes')
				.then(response => {
					this.taxes = response.body
				})
			},
			getPaymentMethods() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.payment_methods = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.loading = true
				this.$http.get('admin/settings/general')
				.then(response => {
					this.data = response.body
					this.loading = false
					this.loadSwitchs()
				}, function(error) {
					console.log(error)
				})
			},
			loadSwitchs() {
				this.$nextTick( () => {
					$('.js-switch').each(function() {
						new Switchery($(this)[0], $(this).data());
					})
				})
			},
			update(column, data) {
				var tr = $('#setting-' + this.data.id + '-' + column)
				tr.addClass('disabled')
				this.$http.put('admin/settings/general/' + this.data.id, data)
				.then(response => {
					this.$set(this.$platform.setting, column, response.body[column])
					tr.removeClass('disabled')
				})
				.catch(response => {
					console.log(response)
					tr.removeClass('disabled')
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/General.vue